import React, { Component } from 'react'
import { connect } from 'react-redux'
import { checkAuth } from 'store/modules/auth/actions'
import AboutComponent from 'bundles/About/components/AboutComponent';

class AboutContainer extends Component {

    componentDidMount() {
        const { loggedIn, checkAuth } = this.props;

        if (!loggedIn) {
            checkAuth();
        }
    }

    render() {
        return (
            <AboutComponent
                {...this.props}
            />
        )
    }
}

const mapStateToProps = (state) => {
    return {
        loggedIn: state.auth.loggedIn,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        checkAuth: () => {
            dispatch(checkAuth())
        },
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(AboutContainer)
